import { FC } from 'react';

import { Text, VSpacing } from '@hh.ru/magritte-ui';
import { MagnifierOutlinedSize24 } from '@hh.ru/magritte-ui/icon';

import useTrls from 'hooks/translation/useTrls';

import styles from 'components/MultiCreationAuction/SearchNotFound/SearchNotFound.module.less';

const TrlKeys = {
    title: 'MultiCreationAuction.SearchNotFound.title',
    text: 'MultiCreationAuction.SearchNotFound.text',
};

export const SearchNotFound: FC = () => {
    const trls = useTrls();
    return (
        <div className={styles.wrapper}>
            <div className={styles.icon}>
                <MagnifierOutlinedSize24 initialColor="tertiary" />
            </div>
            <VSpacing default={32} />
            <div className={styles.textWrapper}>
                <Text typography="title-5-semibold">{trls(TrlKeys.title)}</Text>
                <VSpacing default={8} />
                <Text typography="paragraph-2-regular" style="secondary">
                    {trls(TrlKeys.text)}
                </Text>
            </div>
        </div>
    );
};
